import React from 'react';
import Confirm from './Confirm';
import Success from './Success';
import { ProfileState } from './ProfileContext';
//MUI components
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';

import Validation from './Validation';
import MandatoryDetails from './MandatoryDetails';
import OptionalDetails from './OptionalDetails';
//Alerts
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavigationBlocker from '../../common/NavigationBlocker';
let steps = ['', '', '', ''];

if (window.innerWidth > 600) {
	steps = [
		'Mandatory Details',
		'Optional Details',
		'Confirm',
		'Success',
	];
}

export function CreateProfilePage() {
	const [nextStep, setNextStep] = React.useState(0);
	const [activeStep, setActiveStep] = React.useState(0);
	const [completed, setCompleted] = React.useState({});
	const [tooltip, setTooltip] = React.useState([
		{ label: 'Mandatory Details', open: false },
		{ label: 'Optional Details', open: false },
		{ label: 'Confirm', open: false },
		{ label: 'Success', open: false },
	]);
	const [click, setClick] = React.useState(false);
	const [optionalDetailsVisited, setOptionalDetailsVisited] = React.useState(false);

	React.useEffect(() => {
		toast.info('Please create your profile to access the website', {
			timeOut: 1000,
		});
		const handleBeforeUnload = (e) => {
			e.preventDefault();
			// Most browsers display a default prompt message.
			e.returnValue = '';
		  };
		
		  window.addEventListener('beforeunload', handleBeforeUnload);
		  return () => window.removeEventListener('beforeunload', handleBeforeUnload);
	}, []);

	const totalSteps = () => {
		return steps.length;
	};

	const handleBack = () => {
		setNextStep(activeStep - 1);
		setClick(true);
	};

	const handleComplete = (data, invalidFields, errorFields) => {
		setClick(false);
		if (data) {
			const newCompleted = completed;
			newCompleted[activeStep] = true;
			setCompleted(newCompleted);
			setActiveStep(nextStep);
			// } else {
		} else if (invalidFields && invalidFields.length > 0) {
			toast.error(`Please fill the following fields: ${invalidFields.join(', ')}`, {
				position: toast.POSITION.TOP_RIGHT,
				autoClose: 5000,
			});
		} else if (errorFields && errorFields.length > 0) {
			toast.error(`Please fill the following fields correctly: ${errorFields.join(', ')}`, {
				position: toast.POSITION.TOP_RIGHT,
				autoClose: 5000,
			});
		} else if (activeStep === 2) {
			// 	toast.info('There was an error when creating the profile', {
			// 		timeout: 1000,
			// 	});
			// } else {
			toast.info(
				'There was an unexpected error please reach out to support or try again later',
				{
					timeout: 1000,
				}
			);
		}
	};

	const closeTooltip = () => {
		tooltip.forEach((item, i) => {
			tooltip[i].open = false;
		});
		setTooltip(tooltip);
	};

	const handleStep = (step, i) => () => {
		if (Object.keys(completed).length > i) {
			if (window.innerWidth < 600) {
				tooltip.forEach((item, i) => {
					tooltip[i].open = false;
				});
				tooltip[i].open = true;
				setTooltip(tooltip);
			}
			setNextStep(i);
			setClick(true);
		}
	};
	const renderToast = (message) => {
		toast.info(message, {autoClose: 5000})
	}
	return (
		<ProfileState>
			<NavigationBlocker when={true} message={"Changes you made may not be saved"}/>
			<ToastContainer />
			<div className='Auth-form-container'>
				<div className='max-w-4xl p-4 '>
					<Stepper
						activeStep={activeStep}
						alternativeLabel
						className='stepperClass'
						nonLinear
					>
						{steps.map((label, i) => (
							<Tooltip
								onClose={() => {
									closeTooltip();
								}}
								title={tooltip[i].label}
								open={tooltip[i].open}
								placement='top'
								disableHoverListener
								disableTouchListener
								PopperProps={{
									disablePortal: true,
								}}
							>
								<Step key={i} completed={completed[i]}>
									<StepButton onClick={handleStep(label, i)}>
										{label}
									</StepButton>
								</Step>
							</Tooltip>
						))}
					</Stepper>
					<div>
						{/* Personal details  */}
						{activeStep === 0 && <MandatoryDetails />}
						{/* Career details */}
						{activeStep === 1 && <OptionalDetails 
							optionalDetailsVisited={optionalDetailsVisited} // Pass down the state
							setOptionalDetailsVisited={setOptionalDetailsVisited} // Pass down setter
						/>}
						{/* Social details */}
						{activeStep === 2 && <Confirm />}
						{/* Success */}
						{activeStep === 3 && <Success />}
					</div>
					<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
						<Button
							disabled={activeStep === 0}
							variant='outlined'
							onClick={handleBack}
							sx={{ mr: 2 }}
							color='primary'
						>
							Back
						</Button>
						<Box sx={{ flex: '1 1 auto' }} />
						<Button
							variant='contained'
							onClick={() => {
								setNextStep(activeStep + 1);
								setClick(true);
							}}
							color='primary'
							disabled={nextStep === totalSteps() - 1}
						>
							{activeStep === totalSteps() - 2
								? 'Finish'
								: 'Next'}
						</Button>
					</Box>
				</div>
				{click && (
					<Validation
						style={{ display: 'None' }}
						sendDataForValidation={handleComplete}
						activeStep={activeStep}
						nextStep={nextStep}
						renderToast={renderToast}
					/>
				)}
			</div>
		</ProfileState>
	);
}

export default CreateProfilePage;